const component = {
  template: `
    <div class="textPost">
      <div class="textPost__header" ng-bind-html="$ctrl.header"></div>
      <div class="textPost__text" ng-bind-html="$ctrl.text"></div>
      <div class="textPost__buttons">
        <div class="portalBtn portalBtn--dark" ng-repeat="btn in $ctrl.btn">
          <a href="{{::btn.url}}">{{::btn.title}}
        </div>
      </div>
    </div>
  `,
  bindings: {
    id: '@',
    text: '@',
    buttons: '@',
    header: '@'
  },
  controller() {
    this.$onInit = () => {
      if(this.buttons) {
        this.btn = JSON.parse(decodeURIComponent(this.buttons));
      }
    };
  },
};

export default component;



// WEBPACK FOOTER //
// ./js/containers/causePortal/components/textPost/index.js